/// <reference path="../../../../Scripts/typings/durandal/durandal.d.ts" />
define('areas/organizationmanager/commands/showuserdatacommand',["require", "exports", "durandal/app"], function (require, exports, App) {
    "use strict";
    var ShowUserDataCommand = (function () {
        function ShowUserDataCommand(organizationUri, organizationUrl) {
            this._organizationUri = organizationUri;
            this._organizationUrl = organizationUrl;
        }
        ShowUserDataCommand.prototype.execute = function (symbol) {
            var userData = "";
            var portalUriParts = this._organizationUri.split("\\");
            if (portalUriParts.length > 1) {
                userData = "Zugangsnummer:		" + portalUriParts[1] + "\r\n";
            }
            userData += "Benutzername:	" + symbol.loginName + "\r\n\r\n";
            if (symbol.loginName == "Gateway") {
                userData += "Command Line:	";
                userData += "Addison.Tools.MessageGatewayExplorer.exe /cmd:setlogin /user:" + symbol.id;
                userData += "\r\n\r\n";
            }
            else {
                userData += "Portal URL:	" + this._organizationUrl + "\r\n\r\n";
            }
            //insert id's
            userData += "\r\n\r\nOrganization Id:	" + symbol.organizationId + "\r\n";
            userData += "Networkmember Id:	" + symbol.id;
            App.showDialog("areas/organizationmanager/viewmodels/userdata", userData);
        };
        return ShowUserDataCommand;
    }());
    return ShowUserDataCommand;
});

